import Subtopic from "./Subtopic";
import "../styling/Topic.css"

export default function({ topic, subtopics, progress }) {
    console.log("Progress: ", progress)
    console.log("subtopics: all", subtopics)
    return (
        <div className="topic">
            <div className="topic__container">
                <h1 className="topic__text">{topic.charAt(0).toUpperCase() + topic.slice(1)}</h1>
                {subtopics.map((subtopic) => (
                    <Subtopic 
                        key={`${topic}/${subtopic}`}
                        topic={topic}
                        subtopic={subtopic}
                        progress={progress.get(subtopic) || 0}
                    />
                ))}
            </div>
        </div>
    )
}